import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
  en_US: {
    base: {
      close:            'Close',
      unsupportedVideo: 'Your browser does not support video elements.',
      unsupportedAudio: 'Your browser does not support audio elements.',
      view:             'View',
      remove:           'Remove',
      no:               'No',
      yes:              'Yes',
    },
    bookmark: {
      showOnMap:  "Show on map",
    },
    login: {
      login:              'Login',
      logout:             'Logout',
      createAccount:      'Create Account',
      username:           'Username',
      password:           'Password',
      passwordHint:       'At least 8 characters',
      passwordMatch:      'Password must match',
      reenterPassword:    'Re-enter Password',
      email:              'Email',
      emailMatch:         'Email must match',
      reenterEmail:       'Re-enter Email',
      usernameOrEmail:    'Username or Email',
      signIn:             'Sign In',
      forgotPassword:     'Forgot Password?',
      alreadyRegistered:  'You already have an account?',
      resetPassword:      'Reset Password',
      resetDescription:   'Enter the username or email address you used when creating the account. A message will be sent to that address containing a link to reset your password.',
      resetSuccess:       'An email has been sent with a link to reset the password.',
      resetFailure:       'Failed to send an email with a link to reset the password.',
      registrationSuccess: 'User account has been created successfully.',
      registrationFailure: 'Error creating user account.',
      loginSuccess:       'You have successfully logged in.',
      loginFailure:       'Login failed.',
      logoutSuccess:      'You have successfully logged out.',
    },
    nav: {
      map:          'Map',
      bookmarks:    'Bookmarks',
      help:         'Help',
      returnToHome: 'Return to Home'
    },
    sidenav: {
      filter: {
        filterByType:     'Filter by type',
        filterByYear:     'Filter by year',
        filterByCategory: 'Filter by category',
        filterByAffiliation: 'Filter by spiritual affiliation',
        filterByAffiliationLabel: 'Spiritual affiliation',
        filterByAffiliationHint: 'Select one or more spiritual affiliations',
        images:           'Photos',
        documents:        'Documents',
        audio:            'Audio',
        video:            'Video',
      },
      single: {
        by:                   'by',
        category:             'Category',
        addToBookmarks:       'Add to bookmarks',
        removeFromBookmarks:  'Remove from bookmarks',
        bookmarkAdded:        'Bookmark added.',
        bookmarkRemoved:      'Bookmark removed.',
        download:             'Download',
      }
    },
    search: {
      openMenu:       'Open Menu',
      search:         'Search..',
      searchMemories: 'Search Memories',
      filter:         'Filter items',
    },
    share: {
      share:          'Share this article',
      qrCode:         'QR Code',
      shareQr:        'Share the link via QR code',
      downloadReady:  'Download ready.',
      url:            'URL',
      urlCopied:      'URL copied.',
    },
    views: {
      bookmarks: {
        removeBookmark:     'Remove bookmark',
        removeBookmarkText: 'Are you sure you want to remove the bookmark?',
      },
      help: {
        title: 'Help',
      }
    }
  },
  de_DE: {
    base: {
      close:            'Schließen',
      unsupportedVideo: 'Ihr Browser unterstützt keine Video-Elemente.',
      unsupportedAudio: 'Ihr Browser unterstützt keine Audio-Elemente.',
      view:             'Ansehen',
      remove:           'Entfernen',
      no:               'Nein',
      yes:              'Ja',
    },
    bookmark: {
      showOnMap:  "Auf Karte ansehen",
    },
    login: {
      login:              'Anmelden',
      logout:             'Abmelden',
      createAccount:      'Konto erstellen',
      username:           'Benutzername',
      password:           'Passwort',
      passwordHint:       'Mindestens 8 Zeichen',
      passwordMatch:      'Die Passwörter müssen übereinstimmen',
      reenterPassword:    'Passwort erneut eingeben',
      email:              'E-Mail',
      emailMatch:         'Die E-Mail Adressen müssen übereinstimmen',
      reenterEmail:       'E-Mail erneut eingeben',
      usernameOrEmail:    'Benutzername oder E-Mail',
      signIn:             'Anmelden',
      forgotPassword:     'Passwort vergessen?',
      alreadyRegistered:  'Sie haben bereits ein Konto?',
      resetPassword:      'Passwort zurücksetzen',
      resetDescription:   'Geben Sie den Benutzernamen oder die E-Mail-Adresse ein, die Sie beim Erstellen des Kontos verwendet haben. An diese Adresse wird eine Nachricht gesendet, die einen Link zum Zurücksetzen Ihres Passworts enthält.',
      resetSuccess:       'Eine E-Mail mit einem Link zum Zurücksetzen des Passworts ist versendet worden.',
      resetFailure:       'Fehler beim Versenden einer E-Mail mit einem Link zum Zurücksetzen des Passworts.',
      registrationSuccess: 'Benutzerkonto wurde erfolgreich angelegt.',
      registrationFailure: 'Fehler beim Erstellen des Benutzerkontos.',
      loginSuccess:       'Sie wurden erfolgreich angemeldet.',
      loginFailure:       'Fehler bei der Anmeldung.',
      logoutSuccess:      'Sie wurden erfolgreich abgemeldet.',
    },
    nav: {
      map:          'Karte',
      bookmarks:    'Lesezeichen',
      help:         'Hilfe',
      returnToHome: 'Zurück zur Webseite'
    },
    sidenav: {
      filter: {
        filterByType:     'Filter nach Typ',
        filterByYear:     'Filter nach Jahr',
        filterByCategory: 'Filter nach Kategorie',
        filterByAffiliation: 'Filter nach geistlicher Zugehörigkeit',
        filterByAffiliationLabel: 'Geistliche Zugehörigkeit',
        filterByAffiliationHint: 'Wählen Sie eine oder mehrere geistliche Zugehörigkeiten aus',
        images:           'Bilder',
        documents:        'Dokumente',
        audio:            'Audio',
        video:            'Video',
      },
      single: {
        by:                   'von',
        category:             'Kategorie',
        addToBookmarks:       'Zu Lesezeichen hinzufügen',
        removeFromBookmarks:  'Von Lesezeichen entfernen',
        bookmarkAdded:        'Lesezeichen hinzugefügt.',
        bookmarkRemoved:      'Lesezeichen entfernt.',
        download:             'Herunterladen',
      }
    },
    search: {
      openMenu:       'Öffne Menü',
      search:         'Suchen..',
      searchMemories: 'Erinnerungen suchen',
      filter:         'Beiträge filtern',
    },
    share: {
      share:          'Teile diesen Beitrag',
      qrCode:         'QR-Code',
      shareQr:        'Teile den Link via QR-Code',
      downloadReady:  'Download steht bereit.',
      url:            'URL',
      urlCopied:      'URL kopiert.',
    }
  },
  views: {
    bookmarks: {
      removeBookmark:     'Lesezeichen entfernen',
      removeBookmarkText: 'Möchtest du das Lesezeichen wirklich entfernen?',
    },
    help: {
      title: 'Hilfe',
    }
  }
};

export default new VueI18n({
  locale: window.mmconfig.locale, // set locale
  fallbackLocale: 'en_US',        // set fallback locale
  messages,                       // set locale messages
});
